<template>
  <div>
    <div class="search-box">
      <dev-choose />
    </div>
    <div class="relation-table">
      <relation-table-list />
    </div>
  </div>
</template>
<script>
import DevChoose from './DevChoose'
import RelationTableList from './RelationTableList'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    DevChoose,
    RelationTableList
  },
  computed: {
    ...mapState('config/relation', ['datas'])
  },
  async mounted () {
    const chain = await this.fetchRelationDatas()
    chain.onSuccess(() => {
      document.title = this.$t('message["1365"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
    })
      .fetch()
    const chain2 = await this.fetchRelationDevpDatas()
    chain2.params({ pk: 'inquiry-dev', deal: 1, isshowall: 1 })
      .fetch()
    const chain3 = await this.fetchRelationOrigionDatas()
    chain3.fetch()
  },
  methods: {
    ...mapActions('config/relation', ['fetchRelationDatas', 'fetchRelationDevpDatas', 'fetchRelationOrigionDatas'])
  }
}
</script>
